import * as React from "react";
import { DomainDryRunConfig } from "./domainDryRunConfig";
import { formSet, useCpFormValue } from "../../gvc/testNewForm/utils";
import { store } from "../../../store";
import { Alert, Button } from "antd";
import { useCpFormContext } from "../../../components/form/useCpFormContext";
import { useAppSelector } from "../../../store/hooks";
import { selectOrg } from "../../../store/contextSlice";
import { DomainDryRunConfig as IDomainDryRunConfig } from "../../../schema/types/domain/input";

interface Props {}
export const Ownership: React.FC<Props> = ({}) => {
  const { id } = useCpFormContext();
  const config: IDomainDryRunConfig[] | null = useCpFormValue(`meta.dryRun.ownership.config`);
  const dryRunMessage = useCpFormValue("meta.dryRun.message");
  const mode = useCpFormValue("meta.mode");
  const org = useAppSelector(selectOrg);

  // In basic mode we filter to show only records matching the org - adjust message if only one record
  const displayMessage = React.useMemo(() => {
    if (mode === "basic" && dryRunMessage && config) {
      const filteredCount = config.filter((c) => c.value === org).length;
      if (filteredCount === 1) {
        return dryRunMessage.replace("one of the following TXT records", "the following TXT record");
      }
    }
    return dryRunMessage;
  }, [mode, dryRunMessage, config, org]);

  function onRetry() {
    const form = store.getState().form.instances[id];
    const onBlurCounter = form.meta.onBlurCounter;
    formSet(id, "meta.onBlurCounter", onBlurCounter + 1);
  }

  if (!config) {
    return null;
  }

  return (
    <div>
      {displayMessage ? <Alert className="mb-2 w-fit" showIcon type={`error`} message={displayMessage} /> : null}
      <DomainDryRunConfig label={`Ownership Config`} configs={config} />
      <Button style={{ width: 140 }} className="mt-4" type={`primary`} onClick={onRetry}>
        Retry
      </Button>
    </div>
  );
};
